module.exports = __webpack_public_path__ + "static/media/lockIcon.d76d4378.svg";